import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const Sign = () => {
    const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const[sign,setSign]=useState([])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
   try {
      
       const response = await fetch('http://localhost:8000/api/travel',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(formData)
       })
   
    if(response.ok){
        const newsign = {formData}  
        setSign([...sign,newsign])
        setFormData({name:'',email:'',password:''})
     }else{
      console.log('mistake in sign ')
     }
    
   } catch (error) {
    console.log(error)
    
   }
   alert('singup success',formData)
          
  

  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-sky-200 to-blue-400 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-blue-800 mb-6">
          Travel With Us ✈️ - Sign Up
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Harish"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="example@mail.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition"
          >
            Sign Up
          </button>
        </form>
        <p className="mt-4 text-sm text-center text-gray-600">
          Already have an account? <Link to='Login' className="text-blue-700 underline">Log in</Link>
        </p>
      </div>
    </div>
  );
};


export default Sign
